import { Alert, AlertTitle, Button } from '@mui/material'

/** Shown in place of the navigation when the user's role could not be loaded. */
export const RoleErrorState = ({ onRetry }: { onRetry: () => void }) => (
  <Alert
    severity="error"
    action={
      <Button color="inherit" size="small" onClick={onRetry}>
        Retry
      </Button>
    }
  >
    <AlertTitle>Could not load your permissions</AlertTitle>
    Retry, or log out and sign in again.
  </Alert>
)
